{
  "version": 1,
  "asset_id": "0a56970b-07c4-443d-9963-794a9fa64f57",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0a56970b-07c4-443d-9963-794a9fa64f57/svc-ppc-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0a56970b-07c4-443d-9963-794a9fa64f57/svc-ppc-1200.webp",
  "original_filename": "svc-ppc-1200.webp",
  "size": 12948,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:54Z"
}
